import { WhatsAppContentDefinition } from 'modules/graphql';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useErrorValidationContext } from 'modules/templateEditor/context/ErrorValidationContext';
import { useTemplateReviewTakeoverContext } from 'modules/templateEditor/EditWhatsApp/context/TemplateReviewTakeoverContext';
import { useEditableWhatsApp } from 'modules/templateEditor/EditWhatsApp/hooks/useEditableWhatsApp';
import { BusinessInititatedField } from 'modules/templateEditor/EditWhatsApp/TemplateTypeField';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { LongArrowRight16 } from 'ui/icons';
import { LeftTooltip } from 'ui/tooltip';
import { displayContent } from '../content';

const selectTooltipContent = (hasError: boolean, isMissingSender: boolean) => {
  if (isMissingSender && !hasError) {
    return displayContent.whatsAppTemplateReviewButtonNoSender;
  }
  return displayContent.whatsAppTemplateReviewButtonTooltipContent;
};

export const WhatsAppTemplateReviewButton = () => {
  const { setIsTemplateReviewTakeoverOpen } = useTemplateReviewTakeoverContext();
  const { isEditMode, liveTemplate } = useEditableFieldsContext();
  const { localeContentErrors, localeContentWarnings } = useErrorValidationContext();
  const { isEditableWhatsAppTemplate } = useEditableWhatsApp();

  const errorCount = localeContentErrors.length + localeContentWarnings.length;
  const { whatsAppSenderId } = (liveTemplate?.mediumData || {}) as WhatsAppContentDefinition;

  if (!isEditableWhatsAppTemplate) return null;

  return (
    <LeftTooltip
      isEnabled={!!errorCount || !whatsAppSenderId}
      tooltipContent={selectTooltipContent(!!errorCount, !whatsAppSenderId)}
    >
      <BusinessInititatedField>
        <PrimaryButton
          size={BUTTON_SIZES.LARGE}
          onClick={() => {
            setIsTemplateReviewTakeoverOpen(true);
          }}
          isDisabled={isEditMode || !!errorCount || !whatsAppSenderId}
          data-test="whats-app-template-review-button"
        >
          Review
          <LongArrowRight16 />
        </PrimaryButton>
      </BusinessInititatedField>
    </LeftTooltip>
  );
};
